import { SalesReportApiClient } from "@/clients/salesReportApiClient";
import { SalesReport, TransactionSuggestion } from "@/types/salesReport";

export class SalesReportService {
  private apiClient: SalesReportApiClient;

  constructor() {
    this.apiClient = new SalesReportApiClient();
  }

  async getSalesReports(companyId: string): Promise<SalesReport[]> {
    return this.apiClient.getSalesReports(companyId);
  }

  async getSalesReport(id: string): Promise<SalesReport | null> {
    return this.apiClient.getSalesReport(id);
  }

  async markAsReceivedExternally(
    salesReportId: string,
    receivedDate: string,
    actualSekAmount?: number,
    transactionId?: string,
    bankAccountId?: string,
  ): Promise<boolean> {
    return this.apiClient.markAsReceivedExternally(salesReportId, receivedDate, actualSekAmount, transactionId, bankAccountId);
  }

  async getTransactionSuggestions(salesReportId: string): Promise<TransactionSuggestion[]> {
    return this.apiClient.getTransactionSuggestions(salesReportId);
  }

  async getPrecomputedTransactionSuggestions(salesReportId: string): Promise<TransactionSuggestion[]> {
    return this.apiClient.getPrecomputedTransactionSuggestions(salesReportId);
  }
}
